import Actions from "../NipTypes";

const initialState = {
    isInitiatingTest: false,
    testItems: {},
    initiateSuccess: false,
    isSendingNameEnquiryValues: false,
    sendNameEnquiryValuesSuccess: false,
    sendNameEnquiry: {},
    isSendingFundTransferValues: false,
    sendFundTransferValuesSuccess: false,
    sendFundTransfer: {},
    isSendingStatusQueryValues: false,
    sendStatusQueryValuesSuccess: false,
    sendStatusQuery: {},
    isSubmitting: false,
    submitTestSuccess: false,
    test: {},
    error: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Actions.INITIATE_OUTWARD_TEST_START:
            return {
                ...state,
                isInitiatingTest: true,
                initiateSuccess: false,
                testItems: {},
                error: null,
            };
        case Actions.INITIATE_OUTWARD_TEST_SUCCESS:
            return {
                ...state,
                isInitiatingTest: false,
                initiateSuccess: true,
                testItems: action.payload,
                error: null,
            };
        case Actions.INITIATE_OUTWARD_TEST_FAILURE:
            return {
                ...state,
                isInitiatingTest: false,
                initiateSuccess: false,
                error: action.payload,
            };
        case Actions.SUBMIT_OUTWARD_TEST_START:
            return {
                ...state,
                isSubmitting: true,
                submitTestSuccess: false,
                error: null,
            };
        case Actions.SUBMIT_OUTWARD_TEST_SUCCESS:
            return {
                ...state,
                isSubmitting: false,
                submitTestSuccess: true,
                test: action.payload,
                error: null,
            };
        case Actions.SUBMIT_OUTWARD_TEST_FAILURE:
            return {
                ...state,
                isSubmitting: false,
                submitTestSuccess: false,
                error: action.payload,
            };
        case Actions.RUN_NAME_ENQUIRY_TEST_START:
            return {
                ...state,
                isSendingNameEnquiryValues: true,
                sendNameEnquiryValuesSuccess: false,
                sendNameEnquiry: {},
                error: null,
            };
        case Actions.RUN_NAME_ENQUIRY_TEST_SUCCESS:
            return {
                ...state,
                isSendingNameEnquiryValues: false,
                sendNameEnquiryValuesSuccess: true,
                sendNameEnquiry: action.payload,
                error: null,
            };
        case Actions.RUN_NAME_ENQUIRY_TEST_FAILURE:
            return {
                ...state,
                isSendingNameEnquiryValues: false,
                sendNameEnquiryValuesSuccess: false,
                sendNameEnquiry: {},
                error: action.payload,
            };
        case Actions.RUN_FUND_TRANSFER_TEST_START:
            return {
                ...state,
                isSendingFundTransferValues: true,
                sendFundTransferValuesSuccess: false,
                sendFundTransfer: {},
                error: null,
            };
        case Actions.RUN_FUND_TRANSFER_TEST_SUCCESS:
            return {
                ...state,
                isSendingFundTransferValues: false,
                sendFundTransferValuesSuccess: true,
                sendFundTransfer: action.payload,
                error: null,
            };
        case Actions.RUN_FUND_TRANSFER_TEST_FAILURE:
            return {
                ...state,
                isSendingFundTransferValues: false,
                sendFundTransferValuesSuccess: false,
                sendFundTransfer: {},
                error: action.payload,
            };
        case Actions.RUN_STATUS_QUERY_TEST_START:
            return {
                ...state,
                isSendingStatusQueryValues: true,
                sendStatusQueryValuesSuccess: false,
                sendStatusQuery: {},
                error: null,
            };
        case Actions.RUN_STATUS_QUERY_TEST_SUCCESS:
            return {
                ...state,
                isSendingStatusQueryValues: false,
                sendStatusQueryValuesSuccess: true,
                sendStatusQuery: action.payload,
                error: null,
            };
        case Actions.RUN_STATUS_QUERY_TEST_FAILURE:
            return {
                ...state,
                isSendingStatusQueryValues: false,
                sendStatusQueryValuesSuccess: false,
                sendStatusQuery: {},
                error: action.payload,
            };
        case Actions.CLEAR_NIP_TEST_STATE:
            return {
                isInitiatingTest: false,
                testItems: {},
                initiateSuccess: false,
                isSendingNameEnquiryValues: false,
                sendNameEnquiryValuesSuccess: false,
                sendNameEnquiry: {},
                isSendingFundTransferValues: false,
                sendFundTransferValuesSuccess: false,
                sendFundTransfer: {},
                isSendingStatusQueryValues: false,
                sendStatusQueryValuesSuccess: false,
                sendStatusQuery: {},
                isSubmitting: false,
                submitTestSuccess: false,
                test: {},
                error: null,
            };
        default:
            return state;
    }
};
